"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var ArticlesListModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticlesListModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const LineHeader_form_1 = require("../_components/LineHeader/LineHeader.form");
const ArticlesList_contracts_1 = require("./ArticlesList.contracts");
const ArticlesList_config_1 = require("./ArticlesList.config");
const ArticlesList_helpers_1 = require("./ArticlesList.helpers");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `ArticlesList`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ArticlesListModuleForm = ArticlesListModuleForm_1 = class ArticlesListModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ArticlesListModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     */
    get articlesCount() {
        return typeof this._version !== 'undefined'
            ? ArticlesList_helpers_1.getArticlesCount(this.size, this._version)
            : undefined;
    }
    /**
     * TODO: Description.
     */
    deleteLink() {
        const contentCopy = { ...this._content };
        delete contentCopy.readMoreLink;
        this._content = contentCopy;
    }
    /**
     * TODO: Description.
     */
    findLink() {
        this.pickRelated(services_1.Picker.Content, this.setLink);
    }
    /**
     * Default module's config.
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.ArticlesList,
            size: {
                colSpan: 2,
                rowSpan: 1,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * Default module's content (schema & default values).
     */
    static getInitialContent() {
        return {
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: null,
            allowDuplicates: false,
            header: { text: '', site: '', isLink: false },
            headerLink: null,
            list: {},
            listType: form_2.ListSelectionMode.Default,
            titleVersion: '',
            showArticleTags: true,
            showHeader: true,
            startFromBeginning: false,
            showModuleOnFirstPageOnly: false
        };
    }
    /**
     * TODO: Description.
     */
    get hasLink() {
        return !!this._content.readMoreLink && !!this._content.readMoreLink.value;
    }
    /**
     * Alternative titles version.
     */
    get titleOptions() {
        return [
            { label: `${this.$t('forms.shared.titleVersion.none')}`, value: '' },
            ...Object.values(_contracts_1.TitleVersion).map(value => ({
                label: `${this.$t('forms.shared.titleVersion.' + value)}`,
                value
            }))
        ];
    }
    /**
     * Options for the `<DashmixSelect name="version">`.
     */
    get versionOptions() {
        return Object.values(ArticlesList_contracts_1.ArticlesListVersion).map(value => ({
            label: this.$t(`${ArticlesList_config_1.variantsLabels[value]}`),
            value: value
        }));
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        this._content = merge_1.default(this.initialContent, this._content);
    }
    /**
     * TODO: Description.
     */
    setLink(source) {
        this._content = { ...this._content, readMoreLink: source };
        this.$nextTick(() => {
            this.describeLink();
        });
    }
    /**
     * TODO: Description.
     */
    setList(source) {
        this._content.list = source;
    }
    findHeaderLinkSource(source) {
        this.describe(source);
    }
    /**
     * TODO: Description.
     */
    describeLink() {
        this.describe(this._content.readMoreLink, 'title', 'Nie można wczytać linku');
    }
};
ArticlesListModuleForm = ArticlesListModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticlesListModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect,
            LineHeaderForm: LineHeader_form_1.LineHeaderForm,
            FormErrors: form_2.FormErrors,
            ListSelector: form_2.ListSelector
        },
        mounted() {
            this.$nextTick(() => {
                if (this.hasLink) {
                    this.describeLink();
                }
            });
        },
        template: `
    <div>

      <!-- Articles count -->
      <p v-if="typeof articlesCount === 'number'"
         :class="articlesCount === 0 ? 'text-danger' : 'text-success'">
        {{ $t('forms.shared.articlesCount') }}: <b>{{ articlesCount }}</b>
      </p>

      <hr>

      <!-- Version (module variant) -->
      <div class="form-group">
        <label for="version">{{ $t('forms.shared.modulesVariant') }}</label>
        <DashmixSelect :model.sync="_version" name="version"
                       :options="versionOptions" :searchable="false" />
      </div>

      <div class="form-group col-12 col-md-6">
        <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
        <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                       :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                       :options="backgroundColorOptions" :searchable="false"/>
        <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
      </div>

      <!-- Heading -->
      <LineHeaderForm :header.sync="_content.header" :headerLink.sync="_content.headerLink"
                      :showHeader.sync="_content.showHeader"
                      :pickRelated="pickRelated"
                      :linkDescription="_content.headerLink ? description(_content.headerLink) : ''"
                      @findLinkSource="findHeaderLinkSource" />

      <div class="row">
        <!-- Alternative title -->
        <div class="form-group col-12 col-md-6">
          <label for="version">{{ $t('forms.shared.alternativeTitle') }}</label>
          <DashmixSelect :model.sync="_content.titleVersion" name="titleVersion"
                         :options="titleOptions" :searchable="false" />
        </div>
      </div>

      <!-- Settings -->
      <div class="form-group">
        <!-- Show article's tags -->
        <DashmixCheck :label="$t('forms.tile.options.showArticleTags')" name="showArticleTags"
                      :model.sync="_content.showArticleTags" />

        <DashmixCheck :label="$t('forms.tile.options.showModuleOnFirstPageOnly')" name="showModuleOnFirstPageOnly"
                      :model.sync="_content.showModuleOnFirstPageOnly"/>
      </div>

      <div class="form-group">
        <label for="list_value" class="d-block">{{ $t('forms.articleList.articles') }}</label>
        <ListSelector :mode="mode" :list="_content.list" @update:list="setList"
                      :duplicates="_content.allowDuplicates" :listType.sync="_content.listType"
                      :pickRelated="pickRelated" :relatedService="relatedService" />

        <DashmixCheck :label="$t('forms.shared.allowDuplicates')" name="allowDuplicates"
                      :model.sync="_content.allowDuplicates" />

        <DashmixCheck :label="$t('forms.shared.startFromBeginning')" name="startFromBeginning"
                      :model.sync="_content.startFromBeginning" />
      </div>

      <div class="row form-group">
        <label for="list_value" class="d-block col-12" v-html="$t('forms.articleList.readMore')" />
        <div class="col-11 d-flex align-items-center">
          <template v-if="hasLink">
            <DashmixButton variant="alt" :icon="DashmixIconName.SearchSolid" :label="$t('forms.shared.change')"
                           @click="findLink" />
            <p class="pl-3 mb-0">
              <strong v-html="$t('forms.shared.chosenSource')" />
              {{ description(_content.readMoreLink) }}
            </p>
          </template>

          <template v-else>
            <DashmixButton variant="alt" :icon="DashmixIconName.EditSolid" :label="$t('forms.shared.add')"
                           @click="findLink" />
          </template>
        </div>

        <div class="col-1 d-flex align-items-center p-0">
          <DashmixButton v-if="hasLink" variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                         @click="deleteLink" />
        </div>
      </div>
      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], ArticlesListModuleForm);
exports.ArticlesListModuleForm = ArticlesListModuleForm;
//# sourceMappingURL=ArticlesList.form.js.map